module.exports = __webpack_public_path__ + "static/media/icon-lock-black.fdbb9883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-lock-black.svg
// module id = ./src/assets/images/icon-lock-black.svg
// module chunks = 6